<template>
    <div class="hts-avatar">
        <div
            class="avatar"
            :class="cClass">
            <template v-if="placeholder">
                <div class="avatar__container">
                    <span class="text-xs">
                        {{ placeholder }}
                    </span>
                </div>
            </template>

            <div
                v-else
                class="avatar__container">
                <img
                    ref="img"
                    :src="imgSrc"
                    loading="lazy"
                    @error="checkImage" >
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import colorSize from '~/components/color-size'
const store = $store()

const props = defineProps({
  circle: {
    type: Boolean,
    default: true
  },
  size: String,
  src: String,
  placeholder: String,
  status: Boolean,
  online: Boolean,
  ring: Boolean,
  user: String // id user cần lần avatar
})
const { circle, size, src, placeholder, status, online, ring, user } = toRefs(props)

const { sizeClass } = colorSize(props)

const page = computed(() => store.userConfig.getPage)
const listUsers = computed(() => store.system.companyUsers)

const defaultAvatarUrl = ref('/assets/default-avatar.png')

// lấy url avatar theo prop url hoặc user
const imgSrc = computed(() => {
  if (src && src.value) {
    return src.value
  }

  if (user && user.value) {
    const userData = listUsers.value.filter((item: { [key: string]: any }) => String(item._id) === String(user.value))?.[0] || null
    if (userData && userData.avatar) {
      return userData.avatar
    }
  }

  return defaultAvatarUrl.value
})

const checkImage = (event: any) => {
  const target = event.target as HTMLImageElement

  let errorCount = target.getAttribute('data-error-count') || 0
  errorCount = Number(errorCount) // Chuyển từ chuỗi sang số

  if (errorCount < 1) {
    target.src = defaultAvatarUrl.value
    target.setAttribute('data-error-count', '1') // Đánh dấu lần lỗi thứ 1
  } else {
    target.style.display = 'none'
  }
}
const cClass = computed(() => {
  const temp: { [key: string]: any } = {
    circle: circle.value,
    'has-ring': ring.value,
    [sizeClass.value]: true
  }
  if (placeholder && placeholder.value) {
    temp.placeholder = !!(placeholder && placeholder.value)
  }
  if (status.value) {
    temp.online = online.value
    temp.offline = !online.value
  }
  return temp
})
</script>
